import { render } from "./DefaultDropdown.vue?vue&type=template&id=62663336"
import script from "./DefaultDropdown.vue?vue&type=script&lang=js"
export * from "./DefaultDropdown.vue?vue&type=script&lang=js"
script.render = render

export default script